document.addEventListener('DOMContentLoaded', function () {
    const sliders = document.querySelectorAll('.c-slider');

    sliders.forEach(slider => {
        let currentIndex = 0;
        const slides = slider.querySelectorAll('.c-slider section');
        const slidesLength = slides.length;
        const article = slider.querySelector('.c-slider article');
        const prevButton = slider.querySelector('.slider-controls button:first-child');
        const nextButton = slider.querySelector('.slider-controls button:last-child');
        const dotNavButtons = slider.querySelectorAll('.slider-dotnav button');

        let startX, endX;

        const updateSlides = () => {
            slides.forEach((slide, index) => {
                slide.classList.toggle('active-slide', index === currentIndex);
            });

            article.style.transform = `translateX(-${currentIndex * 100}%)`;

            if (prevButton && nextButton) {
                prevButton.classList.toggle('hidden', currentIndex === 0);
                nextButton.classList.toggle('hidden', currentIndex === slidesLength - 1);
            }

            dotNavButtons.forEach((button, index) => {
                button.classList.toggle('active', index === currentIndex);
            });
        };

        const handleTouchStart = (event) => {
            startX = event.touches[0].clientX;
        };

        const handleTouchEnd = (event) => {
            endX = event.changedTouches[0].clientX;

            const deltaX = endX - startX;

            if (deltaX > 50 && currentIndex > 0) {
                // Swipe right - show previous slide
                currentIndex--;
            } else if (deltaX < -50 && currentIndex < slidesLength - 1) {
                // Swipe left - show next slide
                currentIndex++;
            }

            updateSlides();
        };

        slider.addEventListener('click', event => {
            const target = event.target;

            if (event.target.closest('.prev') === prevButton && currentIndex > 0) {
                currentIndex--;
                updateSlides();
                target.parentNode.blur();
                return;
            }

            if (event.target.closest('.next') === nextButton && currentIndex < slidesLength - 1) {
                currentIndex++;
                updateSlides();
                target.parentNode.blur();
                return;
            }

            dotNavButtons.forEach((button, index) => {
                if (target === button) {
                    currentIndex = index;
                    updateSlides();
                }
            });
        });

        slider.addEventListener('touchstart', handleTouchStart, false);
        slider.addEventListener('touchend', handleTouchEnd, false);

        updateSlides();
    });
});
